var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.addC}},[_vm._v("Add C")])
}
var staticRenderFns = []

export { render, staticRenderFns }